import {
  Autocomplete,
  type AutocompleteProps,
  Box,
  FormControl,
  TextField,
  Typography,
} from "@mui/material";

import { Option } from "api/common/types/common.types";
import { useFieldContext } from "components/Forms/AppForm";

import ErrorMessage from "../../helpers/ErrorMessage";

type SelectFieldProps = Omit<
  AutocompleteProps<Option, true, true, false>,
  "renderInput"
> & {
  options: Option[];
  label: string;
};

const MultiAutocompleteSelect = ({
  options,
  label,
  ...props
}: SelectFieldProps) => {
  const field = useFieldContext<Option[]>();

  return (
    <FormControl fullWidth size="small">
      <Autocomplete
        disablePortal
        size="small"
        options={options}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            error={field.state.meta.errors.length > 0}
          />
        )}
        value={field.state.value}
        onChange={(_e, value) => value && field.handleChange(value)}
        disableListWrap
        selectOnFocus
        clearOnBlur
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderTags={(value) => (
          <Box>
            <Typography sx={{ marginLeft: 1 }}>
              {value.map((v) => v.label)?.join(", ")}
            </Typography>
          </Box>
        )}
        handleHomeEndKeys
        slotProps={{
          popper: {
            sx: {
              boxBlur: "ghostwhite 0px -1px 8px 4px",
              ".MuiAutocomplete-option[aria-selected='true']": {
                backgroundColor: "#ebebeb",
              },
            },
          },
        }}
        {...props}
        multiple={true}
      />
      <ErrorMessage />
    </FormControl>
  );
};
export default MultiAutocompleteSelect;
